export default {
  open: [
    {
      _name: "CSidebarNavTitle",
      _children: ["v2-Ký gửi"],
    },
    {
      _name: "CSidebarNavItem",
      name: "Dữ liệu",
      to: "/v2/products",
      icon: "cil-layers",
      permission: 'product_view'
    },
    {
      _name: "CSidebarNavItem",
      name: "Ký gửi theo dự án",
      to: "/v2/products_by_projects",
      icon: "cil-layers",
      permission: 'product_view_by_projects'
    },
    {
      _name: "CSidebarNavItem",
      name: "Nhập liệu",
      to: "/v2/products/new",
      icon: "cil-layers",
      permission: 'product_input'
    },
    {
      _name: "CSidebarNavItem",
      name: "Thống kê",
      to: "/v2/products/analytics",
      icon: "cil-layers",
      permission: 'product_analytics'
    },
  ],
  limited: [
    {
      _name: "CSidebarNavTitle",
      _children: ["v2-Ký gửi"],
    },
    {
      _name: "CSidebarNavItem",
      name: "Dữ liệu",
      to: "/v2/products",
      icon: "cil-layers",
      permission: 'product_view'
    },
    {
      _name: "CSidebarNavItem",
      name: "Nhập liệu",
      to: "/v2/products/new",
      icon: "cil-layers",
      permission: 'product_input'
    },
  ],
  sale_limited: [
    {
      _name: "CSidebarNavTitle",
      _children: ["v2-Ký gửi"],
    },
    {
      _name: "CSidebarNavItem",
      name: "Dữ liệu",
      to: "/v2/products",
      icon: "cil-layers",
      permission: 'product_view'
    },
    {
      _name: "CSidebarNavItem",
      name: "Ký gửi theo dự án",
      to: "/v2/products_by_projects",
      icon: "cil-layers",
      permission: 'product_view'
    },
    {
      _name: "CSidebarNavItem",
      name: "Nhập liệu",
      to: "/v2/products/new",
      icon: "cil-layers",
      permission: 'product_input'
    },
  ],
};
